import { render, staticRenderFns } from "./SelectJournal.vue?vue&type=template&id=de98015c"
import script from "./SelectJournal.vue?vue&type=script&lang=js"
export * from "./SelectJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports